import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SendCodeType } from '../../../enums/send-code-type.enum';
import { SendOTPCode_Request } from '../../../models/SendOTPCode_Request.model';
import { UtilService } from '../../../services/util.service';
import { OtpService } from '../../../services/otp.service';

@Component({
  selector: 'app-get-code',
  templateUrl: './get-code.component.html',
  styleUrls: ['./get-code.component.scss']
})
export class GetCodeComponent implements OnInit {

  @Input() phones: string[];
  @Output() submitCb: EventEmitter<SendOTPCode_Request> = new EventEmitter<SendOTPCode_Request>();
  otpGetCodeForm: FormGroup;
  isDevMode: boolean;
  isSubmitted: boolean = false;
  isNewForm: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private utilService: UtilService,
    public otpService: OtpService,
  ) { }

  ngOnInit() {
    this.isDevMode = this.utilService.isDevMode();
    this.isNewForm = this.otpService.isNewForm;
    this.otpGetCodeForm = this.formBuilder.group({
      mobile: ['', [Validators.required, Validators.pattern('^[0]{1}[5]{1}[0-9Xx]{8}$')]],
      otpType: 'sms',
    });

    setTimeout(() => {
      this.focusToElement(`div[data-dropdown-id="choosePhone"]`);
    }, 10);
  }

  nextStep() {
    this.isSubmitted = true;

    if (this.otpGetCodeForm.valid || this.isNewForm) {
      let codeType: SendCodeType;
      switch (this.otpGetCodeForm.value.otpType) {
        case 'sms':
          codeType = SendCodeType.SMS;
          break;
        case 'ivr':
          codeType = SendCodeType.IVR;
          break;
        default:
          codeType = SendCodeType.NONE;
      }

      let checkOTP_request: SendOTPCode_Request =
      {
        phoneIndex: this.phones.indexOf(this.otpGetCodeForm.value.mobile),
        sendCodeType: codeType
      };
      this.otpService.getCode = true;
      this.submitCb.emit(checkOTP_request);
      this.otpService.confirmCode = true;
    }
  }

  focusToElement(selector: string) {
    const selectedElement = Array.from(document.querySelectorAll(selector));

    if (selectedElement && selectedElement.length > 0) {
      const nowActiveElement = document.activeElement;
      (nowActiveElement as HTMLElement).blur();
      setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent): any {
    if (event.key === 'Enter') {
      if ((event.target as HTMLElement).dataset.id === 'smsRadioLabel') {
        (document.getElementById('smsRadio') as HTMLInputElement).checked = true;
        this.otpGetCodeForm.controls['otpType'].setValue('sms');
      } else if ((event.target as HTMLElement).dataset.id === 'ivrRadioLabel') {
        (document.getElementById('ivrRadio') as HTMLInputElement).checked = true;
        this.otpGetCodeForm.controls['otpType'].setValue('ivr');
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/login/otp/get-code/get-code.component.ts